import React, { useState, useEffect } from "react";
import SyncLoader from "react-spinners/SyncLoader";
import { ThemeProvider } from "next-themes";

import {
  About,
  Footer,
  Header,
  Skills,
  Testimonial,
  Top,
  Work,
} from "./container";
import { Navbar, StarCanvas } from "./components";
import "./App.scss";

const App = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="app">
      {loading ? (
        <>
          <div className="flex flex-col justify-center items-center h-screen dark:bg-darktheme relative">
            <div className="flex py-5 mt-5">
              <SyncLoader color="#78ffd6" size="25" loading={loading} />
            </div>
            <div className="mt-5 sign">
              <span className="dark_entities text-brandSize sm:text-3xl">
                {" "}
                &#xFF5B;&lt;
              </span>
              <span className="logo-name text-xl sm:text-3xl text-transparent bg-clip-text bg-[#0063DB] dark:text-slate-50">
                HmdDev
              </span>
              <span className="dark_entities text-brandSize sm:text-3xl">
                {" "}
                /&gt;&#xFF5D;
              </span>
            </div>

            <div className="absolute bottom-5">
              <p className="font-comforta font-bold dark:text-slate-50">
                2023 &copy; By Mo lemine Hamdinou
              </p>
            </div>
          </div>
        </>
      ) : (
        <>
          <ThemeProvider attribute="class">
            <Navbar />
            <Header />
            <About />
            <Work />
            <Skills />
            <Testimonial />
            <div className="relative z-0">
              <Footer />
              <StarCanvas />
            </div>
            <Top />
          </ThemeProvider>
        </>
      )}
    </div>
  );
};

export default App;
